import { render, staticRenderFns } from "./rewardPosterEdit.vue?vue&type=template&id=4d1a85c8&scoped=true&"
import script from "./rewardPosterEdit.vue?vue&type=script&lang=js&"
export * from "./rewardPosterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a85c8",
  null
  
)

export default component.exports